import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, NgForm, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Account, ClientData, PortfolioElement } from '../user-profile-details/client-data';
import Swal from 'sweetalert2';
import { RequestService } from 'src/app/services/request.service';
import { ApiService } from 'src/app/services/api.service';
import { MatDialog } from '@angular/material/dialog';
import { RequestSentModalComponent } from '../request-sent-modal/request-sent-modal.component';
import { Router } from '@angular/router';

interface CouponRequest {
  MainCode: number;
  RelationCode: string;
  SymbolCodes:string;
}

@Component({
  selector: 'app-request-coupons',
  templateUrl: './request-coupons.component.html',
  styleUrls: ['./request-coupons.component.scss']
})
export class RequestCouponsComponent implements OnInit {
 isSubmitting = false;
  @Input() selectedAccount: Account;
  titleMessage: string;
  textConfirmMassage: string;
  submitStatus;
  newCoupon: CouponRequest = {} as CouponRequest;
  complaintTypes: any[] = [];
  today = new Date();
  userPortfolio: ClientData;
  userAccounts: Account[];
  companyName: string;
  clientStocks: PortfolioElement[] = [];
  departments: any[] = [];
  selectedAccountControl = new FormControl(null, Validators.required);
  isDialogOpen: any;
  accountList: Account[];
  lang: string;
  
  constructor(
    public translate: TranslateService,
    private requestService: RequestService,
    private apiService: ApiService,
    public dialog: MatDialog,
    private router: Router,
  ) { 
    this.lang = this.translate.currentLang}

  ngOnInit(): void {
    this.accountList = JSON.parse(localStorage.getItem("accList"));
    this.selectedAccount= this.accountList[0];
    this.clientSelected(this.selectedAccount);
    this.fetchUserPortfolio(this.selectedAccount);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedAccount && changes.selectedAccount.currentValue) {
      this.clientSelected(changes.selectedAccount.currentValue);
      this.fetchUserPortfolio(changes.selectedAccount.currentValue);
    }
  }

  fetchUserPortfolio(selectedAcc?) {
    if (selectedAcc) this.selectedAccount = selectedAcc;

    if (this.selectedAccount != null && this.selectedAccount.relationCode) {
      this.requestService.fetchUserPortfolio(this.selectedAccount.relationCode)
        .subscribe((res) => {
          this.clientStocks = res.Portfolio.EGPPortfolio?.Portfolio as PortfolioElement[];
        });
    }
  }


  clientSelected(e: Account) {
       
    this.userAccounts =   JSON.parse(localStorage.getItem("accList")) as Account[];
    this.selectedAccountControl.setValue(null);


  }


  onAccountChange(relationCode: string) {
    if (!this.userAccounts) {
      return;
    }
  
    const selectedAcc = this.userAccounts.find(acc => acc.relationCode === relationCode);
    if (selectedAcc) {
      this.selectedAccount = selectedAcc; 
      this.fetchUserPortfolio(selectedAcc); 
    }
  }
  

  submitCoupon(form: NgForm) {
    if (form && form.valid) {
      this.newCoupon.SymbolCodes = form.value.SymbolCodes;
      this.newCoupon.RelationCode = this.selectedAccount.relationCode;
      // this.newCoupon.MainCode = this.selectedAccount.;
      if (this.translate.currentLang == "ar") {
        this.titleMessage = "تأكيد الطلب";
        this.textConfirmMassage = `برجاء مراجعه البيانات التالية قبل الإرسال 
      الحساب: ${this.selectedAccount.clientNameAr}
      `;
      }
      if (this.translate.currentLang == "en") {
        this.titleMessage = "Coupon Confirmation";
        this.textConfirmMassage = `Please check The Information Before Sending The Coupon Collection
     Account: ${this.selectedAccount.clientNameEn}
    
     `;
      }
      Swal.fire({
        customClass: {
    popup: 'lg-pop-width'
  },
        title: this.titleMessage,
        html:
             "<pre>" +
    this.textConfirmMassage +  this.translate.instant("order-rel-code") +" : " + 
    this.selectedAccount.relationCode + "</br>"+ this.translate.instant("symbolValue") + " : " +
    (this.lang == 'en' 
      ? this.clientStocks.find(stock => stock.SymbolCode === this.newCoupon.SymbolCodes)?.SymbolNameEn 
      : this.clientStocks.find(stock => stock.SymbolCode === this.newCoupon.SymbolCodes)?.SymbolNameAr
    ) +
    "</pre><p>" ,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.translate.instant("yes"),
        cancelButtonText: this.translate.instant("no"),
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.apiService.submitCoupon(this.newCoupon).subscribe(
            (res) => {
              this.isSubmitting = false;
              if (res) this.submitStatus = res;
              form.resetForm();
              Swal.fire({
                position: "center",
                icon: "success",
                title: this.translate.instant("succes-msg"),
                showConfirmButton: false,
                timer: 4500,
              });
              this.router.navigate(['/requests-analysis/requests-table']);
            },
            (err) => {
              Swal.fire({
                position: "center",
                icon: "error",
                title: this.translate.instant("error-msg"),
                showConfirmButton: false,
                timer: 4500,
              });
              this.router.navigate(['/requests-analysis/requests-table']);
            }
          );
          // this.requestSend();
        } else if (!result.isConfirmed) {
          this.isSubmitting = false;
        }
      });
    }
  }

    requestSend(): void {
      // if (this.isDialogOpen) {
      //   return;
      // }
      // this.isDialogOpen = true;
      // const dialogRef = this.dialog.open(RequestSentModalComponent, {
      //   disableClose: false,
      //   width: '40%',
      //   height: '80%',
      //   data: {

      //   },
      //   direction: this.translate.currentLang === 'ar' ? 'rtl' : 'ltr',
      // });
  
      // dialogRef.afterClosed().subscribe(result => {
      //   this.isDialogOpen = false;
      // });
    }
  
}